export default {
  c1: '优先Link号',
  c2: '抢占活动限定元宇宙身份ID开启个人数字资产之旅',
  c3: '以上活动限定元宇宙身份ID已为您准备好',
  c4: '立即领取',
  c5: '恭喜您 ！领取成功 ！',
  c6: '立即去换上新的元宇宙身份ID吧',
  c7: '去换号',
  c8: '温馨提示',
  c9: '成功领取后的14天内可到元宇宙内按 “新获得” 进入换号页面换上此身份ID。如14天內没有更换，此ID则会自动失效',
  c10: '选用此身份ID后还可自行将身份ID铸造为NFT，享受更多权益',
  c11: '感谢您的参与！',
  c12: '您已领取过此号码',
  c13: '查看我的Meta ID',
  c14: '温馨提示',
  c15: '成功领取后的14天内可到元宇宙内按 “新获得” 进入换号页面换上此身份ID。如14天內没有更换，此ID则会自动失效',
  c16: '选用此身份ID后还可自行将身份ID铸造为NFT，享受更多权益',
  c17: '抱歉！',
  c18: '遇到网络或不可预期的错误，请稍后刷新再试，谢谢。',
  c19: '好的',
  c20: '优先Link号！'
}
